module.exports = __webpack_public_path__ + "static/independencia-intelectual-3394baa82b57129b59f779bafa562130.jpg";